/**
 * 색상 관련 유틸리티 함수들
 */
/**
 * 수익/손실에 따른 색상 클래스 반환
 * @param value - 수익/손실 값
 * @returns CSS 클래스명
 */
export function getProfitLossClass(value) {
    if (value > 0)
        return 'positive';
    if (value < 0)
        return 'negative';
    return 'neutral';
}
/**
 * 수익/손실에 따른 색상 스타일 객체 반환
 * @param value - 수익/손실 값 (NaN이면 기본 색상 반환)
 * @param textAlign - 텍스트 정렬 (기본값: 'right')
 * @returns 스타일 객체
 */
export function getProfitLossStyle(value, textAlign = 'right') {
    const baseStyle = { textAlign };
    // NaN이거나 유효하지 않은 값이면 기본 색상 반환
    if (typeof value !== 'number' || isNaN(value)) {
        return { ...baseStyle, color: 'var(--font-color-default)' };
    }
    if (value > 0) {
        return { ...baseStyle, color: 'var(--font-color-buy)' };
    }
    else if (value < 0) {
        return { ...baseStyle, color: 'var(--font-color-sell)' };
    }
    else {
        return { ...baseStyle, color: 'var(--font-color-default)' };
    }
}
/**
 * 수익/손실에 따른 CSS 변수 색상만 반환
 * @param value - 수익/손실 값
 * @returns CSS 색상 변수
 */
export function getProfitLossColor(value) {
    return getProfitLossStyle(value).color;
}
/**
 * 미리 정의된 스타일 객체들
 */
export const predefinedStyles = {
    center: { textAlign: 'center' },
    right: { textAlign: 'right' },
    left: { textAlign: 'left' },
    // 수익/손실 스타일
    profit: { textAlign: 'right', color: 'var(--font-color-buy)' },
    loss: { textAlign: 'right', color: 'var(--font-color-sell)' },
    neutral: { textAlign: 'right', color: 'var(--font-color-default)' },
};
//# sourceMappingURL=style.js.map